// Skills with categories, colors, and icons for visual representation
export const skills = [
  // Frontend
  {
    id: 1,
    name: 'React',
    category: 'frontend',
    color: '#61DAFB',
    abbrev: 'Re',
    icon: 'react',
    description: 'Component-based UI library',
  },
  {
    id: 2,
    name: 'Vue.js',
    category: 'frontend',
    color: '#4FC08D',
    abbrev: 'Vu',
    icon: 'vue',
    description: 'Progressive framework',
  },
  {
    id: 3,
    name: 'JavaScript',
    category: 'frontend',
    color: '#F7DF1E',
    abbrev: 'JS',
    icon: 'javascript',
    description: 'Dynamic programming language',
  },
  {
    id: 4,
    name: 'TypeScript',
    category: 'frontend',
    color: '#3178C6',
    abbrev: 'TS',
    icon: 'typescript',
    description: 'Typed JavaScript superset',
  },
  {
    id: 5,
    name: 'Tailwind CSS',
    category: 'frontend',
    color: '#06B6D4',
    abbrev: 'Tw',
    icon: 'tailwind',
    description: 'Utility-first CSS framework',
  },
  {
    id: 6,
    name: 'Next.js',
    category: 'frontend',
    color: '#FFFFFF',
    abbrev: 'Nx',
    icon: 'nextjs',
    description: 'React framework for production',
  },
  {
    id: 26,
    name: 'React Native',
    category: 'frontend',
    color: '#61DAFB',
    abbrev: 'RN',
    icon: 'react',
    description: 'Cross-platform native applications',
  },
  {
    id: 27,
    name: 'Expo',
    category: 'frontend',
    color: '#FFFFFF',
    abbrev: 'Ex',
    icon: 'expo',
    description: 'Native app platform and tooling',
  },

  // Backend
  {
    id: 7,
    name: 'Python',
    category: 'backend',
    color: '#3776AB',
    abbrev: 'Py',
    icon: 'python',
    description: 'Versatile programming language',
  },
  {
    id: 8,
    name: 'Django',
    category: 'backend',
    color: '#092E20',
    abbrev: 'Dj',
    icon: 'django',
    description: 'High-level Python framework',
  },
  {
    id: 9,
    name: 'Ruby on Rails',
    category: 'backend',
    color: '#CC0000',
    abbrev: 'RoR',
    icon: 'rails',
    description: 'Full-stack web framework',
  },
  {
    id: 10,
    name: 'Node.js',
    category: 'backend',
    color: '#339933',
    abbrev: 'No',
    icon: 'nodejs',
    description: 'JavaScript runtime',
  },
  {
    id: 11,
    name: 'C#',
    category: 'backend',
    color: '#512BD4',
    abbrev: 'C#',
    icon: 'csharp',
    description: 'Microsoft programming language',
  },

  // Database & Cloud
  {
    id: 12,
    name: 'PostgreSQL',
    category: 'database',
    color: '#4169E1',
    abbrev: 'Pg',
    icon: 'postgresql',
    description: 'Advanced SQL database',
  },
  {
    id: 13,
    name: 'SQL',
    category: 'database',
    color: '#CC2927',
    abbrev: 'SQL',
    icon: 'sql',
    description: 'Structured Query Language',
  },
  {
    id: 14,
    name: 'MongoDB',
    category: 'database',
    color: '#47A248',
    abbrev: 'Mg',
    icon: 'mongodb',
    description: 'NoSQL document database',
  },
  // Integrations
  {
    id: 16,
    name: 'SAP Business One',
    category: 'integrations',
    color: '#0FAAFF',
    abbrev: 'SAP',
    icon: 'sap',
    description: 'ERP system integration',
  },
  {
    id: 17,
    name: 'Mirakl',
    category: 'integrations',
    color: '#FF6B35',
    abbrev: 'Mk',
    icon: 'mirakl',
    description: 'Marketplace platform',
  },
  {
    id: 18,
    name: 'ECGrid',
    category: 'integrations',
    color: '#00B4D8',
    abbrev: 'EC',
    icon: 'ecgrid',
    description: 'EDI network provider',
  },
  {
    id: 19,
    name: 'CommerceHub',
    category: 'integrations',
    color: '#6B4CE6',
    abbrev: 'CH',
    icon: 'commercehub',
    description: 'Supply chain platform',
  },
  {
    id: 20,
    name: 'EDI Documents',
    category: 'integrations',
    color: '#2ECC71',
    abbrev: 'EDI',
    icon: 'edi',
    description: 'Electronic data interchange',
  },
  {
    id: 21,
    name: 'Klaviyo',
    category: 'integrations',
    color: '#5FCF80',
    abbrev: 'Kl',
    icon: 'klaviyo',
    description: 'Email marketing platform',
  },

  // Tools
  {
    id: 22,
    name: 'Git & GitHub',
    category: 'tools',
    color: '#F05032',
    abbrev: 'Git',
    icon: 'git',
    description: 'Version control system',
  },
  {
    id: 23,
    name: 'Docker',
    category: 'tools',
    color: '#2496ED',
    abbrev: 'Dk',
    icon: 'docker',
    description: 'Containerization platform',
  },
  {
    id: 24,
    name: 'VPS Servers',
    category: 'tools',
    color: '#7B68EE',
    abbrev: 'VPS',
    icon: 'vps',
    description: 'Server deployment & management',
  },
  {
    id: 25,
    name: 'Figma',
    category: 'tools',
    color: '#F24E1E',
    abbrev: 'Fg',
    icon: 'figma',
    description: 'Design & prototyping tool',
  },
];

export const skillCategories = {
  all: { label: 'All', color: '#39FF14' },
  frontend: { label: 'Frontend', color: '#61DAFB' },
  backend: { label: 'Backend', color: '#339933' },
  database: { label: 'Database & Cloud', color: '#4169E1' },
  integrations: { label: 'Integrations', color: '#FF6B35' },
  tools: { label: 'Tools', color: '#F05032' },
};
